import { render, staticRenderFns } from "./CaregivingClips.vue?vue&type=template&id=3e4669f8"
import script from "./CaregivingClips.vue?vue&type=script&lang=js"
export * from "./CaregivingClips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports